import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-navbar-item gfu-navbar-dropdown" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "_pos-r" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "_px-2"
}
const _hoisted_6 = {
  key: 1,
  class: "gfu-push-notification-list _flexcol"
}
const _hoisted_7 = {
  key: 0,
  class: "_bgc--primary-dark _py-2"
}
const _hoisted_8 = { class: "gfu-balloon__top-title _tc--white _px-2 _pb-2" }
const _hoisted_9 = { class: "_flexcol _gap-1" }
const _hoisted_10 = { class: "_flex _jc-sb _pa-2" }
const _hoisted_11 = { class: "gfu-balloon__top-title" }
const _hoisted_12 = ["href"]
const _hoisted_13 = {
  key: 1,
  class: "_bgc--light _rounded--common _mx-2 _mb-2"
}
const _hoisted_14 = {
  key: 2,
  class: "_bgc--light _rounded--common _mx-2 _mb-2"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_skeleton_notification = _resolveComponent("skeleton-notification")
  const _component_notification_action = _resolveComponent("notification-action")
  const _component_push_notification_unauthorized_user = _resolveComponent("push-notification-unauthorized-user")
  const _component_push_notification_list = _resolveComponent("push-notification-list")
  const _component_base_balloon = _resolveComponent("base-balloon")
  const _component_click_outside = _resolveComponent("click-outside")

  return (_openBlock(), _createBlock(_component_click_outside, { call: $options.onBalloonClose }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          ref: "trigger",
          class: _normalizeClass($options.dropDownClasses),
          tabindex: "0",
          "aria-label": _ctx.Resources.Layout.ActivitySectionTriggerLabel,
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.onNotificationManagerClick && $options.onNotificationManagerClick(...args)))
        }, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_base_icon, {
              name: "bell",
              size: "lg",
              onClick: $options.onNotificationIconClick,
              "data-qa": "header-actions:Notifications"
            }, null, 8 /* PROPS */, ["onClick"]),
            ($options.isNotificationBadgeVisible)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass($options.notificationBadgeClasses),
                  "data-qa": "notification-icon:UnseenNotificationsNumber"
                }, [
                  (_ctx.unseenNotificationsCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.unseenNotificationsCount), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ])
        ], 10 /* CLASS, PROPS */, _hoisted_2),
        _createElementVNode("div", {
          ref: "container",
          class: _normalizeClass($options.contentClasses),
          tabindex: "0"
        }, [
          (_ctx.isBaseBalloonVisible)
            ? (_openBlock(), _createBlock(_component_base_balloon, {
                key: 0,
                width: "wide",
                position: "right",
                "is-pointer-visible": false,
                "data-qa": "notification-box-content"
              }, {
                default: _withCtx(() => [
                  (!_ctx.isContentLoaded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.placeholders, (placeholder) => {
                          return (_openBlock(), _createBlock(_component_skeleton_notification, {
                            key: placeholder,
                            class: "_mt-2"
                          }))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        ($setup.pendingActions.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.Resources.Layout.ActionRequiredSectionTitle), 1 /* TEXT */),
                              _createElementVNode("div", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedPendingActions, (action) => {
                                  return (_openBlock(), _createBlock(_component_notification_action, _mergeProps({
                                    key: action.userPendingActionID
                                  }, { ref_for: true }, action, {
                                    class: "_px-2",
                                    onActionDismissed: $options.onActionDismissed
                                  }), null, 16 /* FULL_PROPS */, ["onActionDismissed"]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.Resources.Layout.ActivitySectionTitle), 1 /* TEXT */),
                          (_ctx.isAuthenticated)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "_tc--accent _tdn",
                                href: _ctx.subscriptionManagementUrl,
                                onClick: _cache[1] || (_cache[1] = (...args) => ($options.onLinkClick && $options.onLinkClick(...args))),
                                "data-qa": "notification-box-link:CommunicationPreferences"
                              }, _toDisplayString(_ctx.Resources.Layout.CommunicationPreferencesLink), 9 /* TEXT, PROPS */, _hoisted_12))
                            : _createCommentVNode("v-if", true)
                        ]),
                        ($options.isPushNotificationSettingsVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent($options.component), {
                                "active-change": "",
                                notifications: $setup.notifications,
                                onHidePushNotificationSettings: $options.onHidePushNotificationSettings
                              }, null, 40 /* PROPS, NEED_HYDRATION */, ["notifications", "onHidePushNotificationSettings"]))
                            ]))
                          : _createCommentVNode("v-if", true),
                        (!$options.hasPushNotificationCapability && !_ctx.isAuthenticated)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_push_notification_unauthorized_user)
                            ]))
                          : _createCommentVNode("v-if", true),
                        (_ctx.isAuthenticated)
                          ? (_openBlock(), _createBlock(_component_push_notification_list, {
                              key: 3,
                              "active-change": "",
                              notifications: $setup.notifications
                            }, null, 8 /* PROPS */, ["notifications"]))
                          : _createCommentVNode("v-if", true)
                      ]))
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["call"]))
}